import LandingSection from '../components/LandingSection/LandingSection';

function HomePage() {
  return <LandingSection />;
}

export default HomePage;
